import { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import JellyTabsList from "@/components/JellyTabsList";
import TournamentPreviewCard from "@/components/TournamentPreviewCard";

export default function Tournaments() {
  const [items, setItems] = useState([]);
  const [view, setView] = useState("lista");
  useEffect(() => { api.get("/public/tournaments").then(r => setItems(r.data)).catch(()=>{}); }, []);

  const byMonth = items.reduce((acc, t) => {
    const key = (t.date || "0000-00").slice(0, 7);
    (acc[key] ||= []).push(t);
    return acc;
  }, {});

  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="text-4xl sm:text-5xl font-semibold text-white">Calendário GSX</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">Torneios oficiais, competições internas e eventos FIDE curados para os atletas do Grupo Santo de Xadrez.</p>

        <Tabs value={view} onValueChange={setView} className="mt-10">
          <JellyTabsList value={view} label="Visualização dos torneios" items={[
            { value: "lista", label: "Lista", testid: "tab-tournaments-list" },
            { value: "mes", label: "Por Mês", testid: "tab-tournaments-month" },
          ]} />

          <TabsContent value="lista" className="mt-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((t) => (
                <TournamentCard key={t.id} t={t} />
              ))}
              {items.length === 0 && (
                <Card className="bg-transparent gsx-card-dark p-8 col-span-full text-center text-slate-400">
                  Nenhum torneio publicado ainda.
                </Card>
              )}
            </div>
          </TabsContent>

          <TabsContent value="mes" className="mt-6 space-y-8">
            {Object.entries(byMonth).sort().map(([k, arr]) => (
              <div key={k}>
                <h3 className="text-xl text-amber-300 font-semibold uppercase tracking-widest mb-4">{k}</h3>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {arr.map((t) => <TournamentCard key={t.id} t={t} />)}
                </div>
              </div>
            ))}
          </TabsContent>
        </Tabs>
      </div>
    </PublicLayout>
  );
}

function TournamentCard({ t }) {
  return (
    <TournamentPreviewCard
      tournament={t}
      testId={`public-tournament-${t.id}`}
      detailsTestId={`public-tournament-details-${t.id}`}
      variant="full"
    />
  );
}
